import React from 'react'
import Header_Kratos from '../LayoutMain_Kratos/Header_Kratos'

export default function DashboardMain_Kratos(props) {
  return (
    <>
      <Header_Kratos />
      {props.children}
    </>
  )
}
